module.exports = __webpack_public_path__ + "static/maxthon-960c05074b0f4bc96d43cafe35bff546.png";